"use client";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type LanguageSwitcherProps = {
  className?: string;
};

const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith("fr") ? "fr" : "en";

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border border-border text-xs shrink-0",
        className,
      )}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => i18n.changeLanguage("en")}
        className={cn(
          "px-2.5 py-1.5 rounded-l-md transition-colors min-w-[2.25rem]",
          currentLang === "en"
            ? "bg-primary text-primary-foreground font-medium"
            : "text-muted-foreground hover:bg-secondary",
        )}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => i18n.changeLanguage("fr")}
        className={cn(
          "px-2.5 py-1.5 rounded-r-md transition-colors min-w-[2.25rem]",
          currentLang === "fr"
            ? "bg-primary text-primary-foreground font-medium"
            : "text-muted-foreground hover:bg-secondary",
        )}
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
